// axios
import axios from 'axios'
import Vue from 'vue'
import router from '@/router'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_URL_API,

  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})
// eslint-disable-next-line no-console
console.log('API URL:', process.env.VUE_APP_URL_API)
axiosIns.defaults.withCredentials = true
axiosIns.defaults.withXSRFToken = true

axiosIns.interceptors.request.use(config => {
  // Do something before request is sent
  const accessToken = localStorage.getItem('access_token')

  config.headers.Accept = 'application/json'
  // eslint-disable-next-line no-param-reassign
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }

  return config
})
axiosIns.interceptors.response.use(
  config => {
    config.headers = {
      Accept: 'application/json',
    }

    return config
  },
  error => {
    switch (error.response.status) {
      case 422:
        // intercepta erro 422
        var errors = error.response.data

        var html = ''
        if (typeof errors === 'object') {
          for (const error in errors.errors) {
            html += `<p>${errors.errors[error]}</p>`
          }
        }
        if (typeof errors === 'string') {
          html = errors
        }

        Vue.swal({
          position: 'center',
          html,
          icon: 'error',
          title: 'Erro',
        })
        break
      case 401:
        // intercepta erro 401
        Vue.$toast.clear()
        localStorage.removeItem('access_token')
        localStorage.removeItem('conected')
        localStorage.removeItem('userAbility')
        if (router.currentRoute.name !== 'auth-login') {
          Vue.$toast.error('Login expirado')
          router.push({ name: 'auth-login' })
        }
        break

      case 403:
        // intercepta erro 403
        Vue.$toast.clear()
        localStorage.removeItem('access_token')
        localStorage.removeItem('conected')
        localStorage.removeItem('userAbility')
        if (router.currentRoute.name !== 'auth-login') {
          Vue.$toast.error('Login expirado')
          router.push({ name: 'auth-login' })
        }
        break
      case 500:
        // intercepta erro 500
        // Vue.$toast.error("Erro no servidor")
        break
      case 423:
        // não faz nada poque vai ser iteceptado no catch
        // da promisse q fez a requisição

        break

      default:
        // Vue.$toast.error("Erro inesperado")
        break
    }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
